import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

export default function LoginRedirectionPage(props) {
  
  const navigate = useNavigate();
  
  useEffect(() => {
		navigate('/login');
  }, [])

  return (<></>)
}